import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as MachineActivityActions from '../_actions/machineActivity';
import { MachineActivity } from '../_models/machinaries/machineActivity';

export interface MachineActivityState extends EntityState<MachineActivity> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<MachineActivity> = createEntityAdapter<MachineActivity>();

const initialState: MachineActivityState = adapter.getInitialState({
  loading: false,
  error: null,
});

const machineActivityReducer = createReducer(
  initialState,

  on(MachineActivityActions.loadMachineActivities, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(MachineActivityActions.loadMachineActivitiesSuccess, (state, { machineActivities }) =>
    adapter.setAll(machineActivities, { ...state, loading: false })
  ),

  on(MachineActivityActions.loadMachineActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MachineActivityActions.addMachineActivitySuccess, (state, { machineActivity }) =>
    adapter.addOne(machineActivity, state)
  ),

  on(MachineActivityActions.updateMachineActivitySuccess, (state, { machineActivity }) =>
    adapter.upsertOne(machineActivity, state)
  ),

  on(MachineActivityActions.deleteMachineActivitySuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    MachineActivityActions.addMachineActivityFailure,
    MachineActivityActions.updateMachineActivityFailure,
    MachineActivityActions.deleteMachineActivityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: MachineActivityState | undefined, action: Action) {
  return machineActivityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
